import { captureError } from '@smg-real-estate/browser-rum';

import { post } from '@/api/fetch';

export interface ListingPerformanceStats {
  totalViews: number;
  totalLeads: number;
  objectReference: string;
  dailySnapshots: ListingPerformanceSnapshot[];
}

export interface ListingPerformanceSnapshot {
  date: string;
  views: number;
  leads: number;
  viewsToDate: number;
  leadsToDate: number;
}

export async function getListingPerformanceStats(
  userId: string,
  insertionIds: string[],
): Promise<ListingPerformanceStats[]> {
  const baseUrl = import.meta.env.VUE_APP_INSERTION_FUNNEL_API_BASE_URL;
  const url = `${baseUrl}/users/${userId}/listing-performance-stats`;
  const body = JSON.stringify({ insertionIds });
  try {
    const response = await post(url, body);
    return response.json();
  } catch (error) {
    captureError(error, {
      service: 'listing-performance-stats',
      action: 'get-listing-performance-stats',
      userId,
      insertionIds,
    });
    throw error;
  }
}
